import Text from '@cartwhl/ui/base/Text';

import GreenLink from 'components/GreenLink';
import { useModal } from 'modals';

const engagementItems = [
  {
    title: 'Pre-built datasets',
    description: 'Curated datasets for common application areas.',
  },
  {
    title: 'Custom data programs',
    description:
      'Targeted capture and generation aligned to specific behaviors',
  },
  {
    title: 'Ongoing data partnerships',
    description: 'Long-term programs supporting model training and iteration',
  },
];

export default function EngagementSection() {
  const { open } = useModal();

  return (
    <section className="pb-(--vertical-spacing)">
      <div className="container">
        <Text
          as="h2"
          variant="web/display/xl"
          lg:variant="web/display/3xl"
          className="max-w-[460px] whitespace-pre-line lg:max-w-[850px]"
        >
          Flexible engagements,{'\n'}from single datasets to partnerships
        </Text>

        <div className="mt-12 grid gap-4 md:grid-cols-3 lg:mt-16">
          {engagementItems.map((item) => (
            <div key={item.title} className="flex flex-col gap-6">
              <div className="flex flex-col gap-2">
                <Text
                  as="h3"
                  variant="web/body/medium/lg"
                  lg:variant="web/body/medium/xl"
                >
                  {item.title}
                </Text>
                <Text
                  as="p"
                  variant="web/body/medium/md"
                  lg:variant="web/body/medium/24"
                  className="text-tertiary"
                >
                  {item.description}
                </Text>
              </div>
            </div>
          ))}
        </div>

        <GreenLink
          onClick={() =>
            open('ENTERPRISE_CONTACT', { reason: 'partnership_inquiry' })
          }
          className="mt-12 block"
        >
          Talk to us about your data needs
        </GreenLink>
      </div>
    </section>
  );
}
